import script from "./WoononPhaseCreateOrder.vue?vue&type=script&lang=ts&setup=true"
export * from "./WoononPhaseCreateOrder.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__